import ReferentListResourceModel from '../../generated/types/model/resource/ReferentListResourceModel';
import ISchedulerListEntry from '../interfaces/ISchedulerListEntry';
import BaseSchedulerListEntryMixin from '../mixin/BaseSchedulerListEntryMixin';

export default class ReferentListResourceViewModel extends BaseSchedulerListEntryMixin(ReferentListResourceModel) implements ISchedulerListEntry {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
